import { t } from '../../i18n';
// admin-client/src/components/lounge/LoungeUploadBanner.jsx
import React from 'react';
export default function LoungeUploadBanner({ onClick, uploadFee = 60, periodDays = 30, disabled = false }) {
    return (<button type="button" onClick={onClick} disabled={disabled} className="w-full bg-gray-100 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed transition rounded-xl py-6 px-6 text-center border border-gray-200">
      <div className="flex items-center justify-center gap-2">
        <div className="text-base font-semibold text-gray-900">{t("\uB77C\uC6B4\uC9C0 \uC5C5\uB85C\uB4DC")}{Number(periodDays || 30)}{t("\uC77C/")}{Number(uploadFee || 60).toLocaleString()}USDT</div>
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-500 text-white text-xs">
          ⬆
        </span>
      </div>
      <div className="text-xs text-gray-500 mt-1">{t("\uC800\uC7A5\uC740 \uBB34\uB8CC, \uCD5C\uCD08 \uAC8C\uC2DC \uC2DC\uC5D0\uB9CC \uC5D0\uC774\uC804\uD2B8 \uC790\uC0B0\uC5D0\uC11C \uBE44\uC6A9\uC774 \uCC28\uAC10\uB429\uB2C8\uB2E4.")}</div>
    </button>);
}
